import { Navigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useCurrentTeam } from '@/providers/TeamProvider';
import { usePurchaseOrder } from '@/hooks/api/0570_purchase_order';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { toastError } from '@/lib/toast';

type Props = { children?: React.ReactNode };

export const RequirePurchaseOrder = (props: Props) => {
  const { identifier, team_id, purchase_order_id } = useParams();
  const { me } = useCurrentTeam();
  const { data, status } = usePurchaseOrder({ identifier: identifier!, team_id: Number(team_id!), id: Number(purchase_order_id!) });
  const { _po_, set_po_, setMePurchaseOrderMember } = useCurrentPurchaseOrder();

  useEffect(() => {
    if (data) {
      set_po_((_) => data);
      setMePurchaseOrderMember((_) => data.purchase_order_members.find((m) => m.user.id == me!.id));
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  if (_po_) {
    return <>{props.children}</>;
  }

  return <></>;
};
